import { MediaQuery } from 'svelte/reactivity';
import { BreakpointExtraSmallMinWidth, BreakpointSmallMinWidth, BreakpointMediumMinWidth, BreakpointLargeMinWidth, BreakpointExtraLargeMinWidth, } from '../tokens/generated-tokens/javascript/es6';
/**
 * Returns the current screen width in rem units
 *
 * @returns {number} The screen width in rems
 */
export function getScreenWidthInRem() {
    const screenWidthInPx = window.innerWidth;
    const rootFontSizeInPx = Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
    return screenWidthInPx / rootFontSizeInPx;
}
/**
 * Returns whether the current screen width is at least the given min-width breakpoint
 *
 * @param {string} minWidth A CSS-compatible min-width string (e.g. "64rem")
 * @returns {boolean} True if the current screen width matches the media query, false otherwise
 */
function isMinWidth(minWidth) {
    return new MediaQuery(`min-width: ${minWidth}`).current;
}
export function isAtLeastExtraSmallScreen() {
    return isMinWidth(BreakpointExtraSmallMinWidth);
}
export function isAtLeastSmallScreen() {
    return isMinWidth(BreakpointSmallMinWidth);
}
export function isAtLeastMediumScreen() {
    return isMinWidth(BreakpointMediumMinWidth);
}
export function isAtLeastLargeScreen() {
    return isMinWidth(BreakpointLargeMinWidth);
}
export function isAtLeastExtraLargeScreen() {
    return isMinWidth(BreakpointExtraLargeMinWidth);
}
/**
 * Detects if the current device supports touch input using both ontouchstart and maxTouchPoints for broad compatibility
 *
 * @returns {boolean} True if the device is touch-capable, false otherwise
 */
export function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
